import { useState } from 'react';

import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption
} from 'reactstrap';

const items = [
  {
    src: 'https://images.vantagefit.io/2021/09/Startup-city-logo.png',
    altText: 'AI has transformed lives and workplace wellness through its amplifying abilities. By stepping into the 21st century, you can see and feel the colossal changes or the impact of Healthcare technology that reassures humankind',
    caption: 'The Rising Need of AI Health Tech for Employee Health & Wellness In The Long-Run',
    imagealtText:'The Rising Need of AI Health Tech for Employee Health & Wellness In The Long-Run',
     link:'https://startup.siliconindia.com/viewpoint/cxoinsights/the-rising-need-of-ai-health-tech-for-employee-health-wellness-in-the-longrun-nwid-28844.html'
  },
  {
    src: 'https://images.vantagefit.io/2021/04/Pittsburg.png',
    altText: 'In a bid to contribute to the corporate employee health across the globe, Vantage Circle is hosting a Global Corporate Virtual Walkathon to mark its 10th anniversary under its flagship product Vantage Fit from 30th January-1st March 2021',
    caption: 'Vantage Circle organizes Virtual Walkathon to promote corporate employee health',
    imagealtText:'Vantage Circle organizes Virtual Walkathon to promote corporate employee health',
    link:'http://markets.post-gazette.com/postgazette/news/read/40867495'
  },
  {
    src: 'https://images.vantagefit.io/2021/04/HRWorld.png',
    altText: 'Fitness is a topic that has been gaining a lot of popularity from people of all backgrounds. From schools to organizations, fitness activities are now promoted and encouraged for immense benefits in health and wellbeing',
    caption: 'How Physical Fitness is directly related to Organisational Productivity',
    imagealtText:'How Physical Fitness is directly related to Organisational Productivity',
     link:'https://hr.economictimes.indiatimes.com/news/trends/employee-experience/how-physical-fitness-is-directly-related-to-organisational-productivity/81252151'
  },
  {
    src: 'https://images.vantagefit.io/2021/04/business-standard-logo-2.png',
    altText: 'The Global Corporate Virtual Walkathon hosted by Vantage Fit from 30th January to 1st March 2021, witnessed the participation of over 3700 employees from more than 24 countries',
    caption: 'Vantage Fit announces winner of its Global Corporate Virtual Walkathon',
    imagealtText: 'Vantage Fit announces winner of its Global Corporate Virtual Walkathon',
     link:'https://www.business-standard.com/content/press-releases-ani/vantage-fit-announces-winner-of-its-global-corporate-virtual-walkathon-121031100635_1.html'
  }
];

const GCWcarousel = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  }

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  }

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  }

  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
        <div className='gcw-carousel d-flex justify-content-lg-around align-items-lg-center flex-column flex-lg-row  py-4 col-12' style={{ height: 'auto' }}>
            <div className='col-12 col-lg-5'>
                <img src={item.src} className='max-w lozad' style={{ borderRadius: '10px', boxShadow: '2px 1px 10px #ddd' }}/>
            </div>
            <div className='col-12 col-lg-7 mt-5 mt-lg-0'>
                <h2 className='text-center text-lg-left excerpt'>{item.caption}</h2>
                <p className='text-center text-lg-left excerpt'>{item.altText}...</p>
                <div><a href = {item.link} className='red-font cta_b mx-auto mx-lg-0 my-3 cursor-pointer'>Read More</a></div>
            </div>
        </div>

      </CarouselItem>
    );
  });

  return (
    <>
    <Carousel
      activeIndex={activeIndex}
      next={next}
      previous={previous}
    >
      <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
      {slides}

    </Carousel>
    <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
      <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
    </>
  );
}

export default GCWcarousel
